const isBrowser = typeof window !== "undefined";

export { isBrowser };
//# sourceMappingURL=is-browser.mjs.map
